import React, {useEffect, useState} from 'react';
import axios from "axios";
import {parse, parseSync } from "subtitle";
import Styles from "./Subtitle.module.scss";

function SubtitleContainer({playedSeconds, url, isCinema, isUseTrack}) {

    let [subtitles, setSubtitles] = useState([])
    let [current, setCurrent] = useState('')

    useEffect(() => {
        load()
    }, [url]);

    useEffect(()=>{
        handleProgress(playedSeconds)
    }, [playedSeconds])

    const load = async () => {
        let {data} = await axios.get(url, {});
        setSubtitles(parseSync(data).filter(line => line.type === 'cue'));
    }

    const handleProgress = ( playedSeconds ) => {
        const cue = subtitles.find(
            ({ data }) => playedSeconds >= data.start / 1000 && playedSeconds <= data.end / 1000
        );
        setCurrent(cue ? cue.data.text : '');
    };

    return (
        <div className={Styles.Container}>
            {
                isUseTrack &&
                <div className={`${Styles.SubtitleArea} ${isCinema ? Styles.Cinema : ''}`}>
                    {
                        current
                    }
                </div>
            }
        </div>
    );

}

export default SubtitleContainer;